// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { caseInsensitiveEnum } from '@/constants/case-insensitive-enum';
import { z } from 'zod';

// Mirrors `enums.BillingSchedule` on the BE. PERIODIC plans bill on a
// recurring cadence; MILESTONE plans bill one charge per phase
// achievement.
export const chargeScheduleSchema = caseInsensitiveEnum([
  'PERIODIC',
  'MILESTONE',
]);

export type ChargeSchedule = z.infer<typeof chargeScheduleSchema>;

export const CHARGE_SCHEDULE = {
  PERIODIC: 'PERIODIC',
  MILESTONE: 'MILESTONE',
} as const satisfies Record<ChargeSchedule, ChargeSchedule>;
